// extracted by mini-css-extract-plugin
export default {"infoList":"basicInformation_infoList__8Gnix","infoItem":"basicInformation_infoItem__mCVLp"};